import React, { useEffect, useContext } from "react";
import { useMediaQuery } from "@mui/material";
import LoanEMICalculators from "./LoanEMICalculators";
import "../FinancialCalculators.css";
import { Link } from "react-router-dom";
import MetadataContext from "../../Pages/MetadataContext";

const EmiCalculators = () => {
  const isSmallScreen = useMediaQuery("(max-width:576px)");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const { setMetadata } = useContext(MetadataContext);

  useEffect(() => {
    setMetadata({
      pageTitle: "MinEmi Loan EMI Calculators | Minemi.ai",
      pageDescription:
        "Calculate your loan EMIs effortlessly with MinEmi Loan EMI Calculators. Plan your finances smartly with accurate, quick, and easy-to-use tools at Minemi.ai.",
      pageKeywords:
        "Loan EMI Calculator, EMI Calculator Online, MinEmi Calculator, Loan Repayment Calculator, Personal Loan EMI Calculator, Home Loan EMI Calculator, Car Loan EMI Calculator, Financial Planning Tools, Minemi.ai EMI Tools, Loan Interest Calculator",
      canonicalUrl: "https://minemi.ai/calculators/emi-calculators",
    });
  }, [setMetadata]);
  return (
    <>
      <div id="financial_calculator__container" className="w-100">
        {/* Hero Section Starts Here */}
        <section id="hero_section" className="w-100">
          <p className="pages_links bg-transparent links ">
            <Link
              to="/"
              underline="hover"
              className="bg-transparent archivo"
              style={{
                fontSize: isSmallScreen ? 13 : 16,
                color: "#59266d",
                cursor: "pointer",
                fontFamily: "'Archivo', sans-serif",
              }}
            >
              Home
            </Link>
            &nbsp;
            <span
              className="d-none d-md-inline bg-transparent ps-1 px-1 "
              style={{
                color: "#59266D",
                fontFamily: "'Archivo', sans-serif",
                fontWeight: 700,
              }}
            >
              &gt;
            </span>
            &nbsp;
            <Link
              to="/calculators"
              underline="hover"
              className="d-none d-md-inline bg-transparent archivo"
              style={{
                fontSize: isSmallScreen ? 13 : 16,
                color: "#59266d",
                cursor: "pointer",
                fontFamily: "'Archivo', sans-serif",
              }}
            >
              Calculators
            </Link>
            &nbsp;
            <span
              className="d-none d-md-inline bg-transparent ps-1 px-1 "
              style={{
                color: "#59266D",
                fontFamily: "'Archivo', sans-serif",
                fontWeight: 700,
              }}
            >
              &gt;
            </span>
            &nbsp;
            <Link
              to="/calculators/emi-calculators"
              underline="hover"
              className="d-none d-md-inline fw-bold bg-transparent archivo"
              style={{
                fontSize: isSmallScreen ? 13 : 16,
                color: "#59266d",
                cursor: "pointer",
                fontFamily: "'Archivo', sans-serif",
              }}
            >
              EMI Calculators
            </Link>
          </p>
          <div
            id="hero_container"
            className="d-flex flex-column flex-md-row align-items-center justify-content-between  w-100"
          >
            <div id="" className="hero-headings">
              <h1>MinEmi Loan EMI Calculators</h1>
              <p className="mt-2">
                MinEmi Loan EMI Calculators help you estimate monthly payments
                for home, car, and personal loans with ease.
              </p>
            </div>
            <div>
              <img
                src="https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/hero_img-1745056661887.webp"
                alt="hero_img"
                loading="lazy"
                className="hero_img"
              />
            </div>
          </div>
        </section>
        {/* Hero Section Ends Here */}

        <section id="main-section" className="">
          <LoanEMICalculators />
        </section>
      </div>
    </>
  );
};

export default EmiCalculators;
